import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ModalMessageEntities } from "@/domain/entities/MainApp";

export function Confirmable(modal: ModalMessageEntities) {
  return function <T, K extends keyof T>(_target: T, _key: K | symbol, descriptor: PropertyDescriptor) {
    const original = descriptor.value;

    descriptor.value = function(...args: any[]) {
      MainAppController.showMessageModal(
        new ModalMessageEntities({
        ...modal,
        onSubmit: () => {
          original.apply(this, args)
          MainAppController.closeMessageModal();
        },
        onClose: () => {
          MainAppController.closeMessageModal();
        }
      }))
    }
    return descriptor
  }
}

